/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：334
 */

var r = require(/* 309 */"../1771/309")
var /* [auto-meaningful-name] */$hasOwnProperty = {}.hasOwnProperty
module.exports = Object.hasOwn || function (e, t) {
  return $hasOwnProperty.call(r(e), t)
}
